import { httpWithAuth } from '~/clients';
import { getCreditStatus } from '~/constants/endpoints';
import { CreditStatusResponse } from '../home/contracts/FinanceData';

export default function fetchCreditStatusNoTrade(
  userId: string,
  controller: AbortController
) {
  return httpWithAuth.get<Partial<CreditStatusResponse>>(
    getCreditStatus(userId),
    { signal: controller.signal }
  );
}
